module.exports = __webpack_public_path__ + "static/img/loading.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/images/loading.gif
// module id = b569
// module chunks = 0